import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { registerServiceWorker } from './lib/sw';

registerServiceWorker();

async function enableMocks() {
  // MSW is dev/test only (§11b). In production builds `import.meta.env.DEV` is false, so this branch and
  // the dynamic import are removed entirely (asserted by scripts/assert-no-msw.mjs after build).
  if (!import.meta.env.DEV) return;
  const url = new URL(window.location.href);
  const flag = url.searchParams.get('mock');
  if (flag === '1') sessionStorage.setItem('wd-mock', '1');
  if (flag === '0') sessionStorage.removeItem('wd-mock');
  if (import.meta.env.VITE_MOCK !== '1' && sessionStorage.getItem('wd-mock') !== '1') return;
  const { startMocks } = await import('./mocks/browser');
  await startMocks();
}

void enableMocks().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
